import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import { AlertSeverityEnum } from "@/shared/interfaces";
import { useUiStore } from "@/store/ui";
import { Image } from "@mui/icons-material";
import { CardMedia, Grid, IconButton, Typography } from "@mui/material";
import { useState } from "react";

interface InfoImgProductoProps {
  urls_imagenes: string[]
}
export default function InfoImgProducto({ urls_imagenes }: InfoImgProductoProps) {

  const setAlert = useUiStore(s => s.setAlert);


  const [urlImagen, setUrlImagen] = useState<string[]>([])
  const [open, setOpen] = useState<boolean>(false);

  return (
    <>
      <IconButton
        onClick={() => {
          if (urls_imagenes) {
            setUrlImagen(urls_imagenes || [])
            setOpen(true);
            return;
          }
          setAlert(true, 'No hay imagenes cargadas', AlertSeverityEnum.info)
        }}
      >
        <Image />
      </IconButton>

      {
        <ScrollableDialogProps
          onCloseIcon={() => setOpen(false)}
          open={open}
          title={"Inventariable"}
          contentNode={
            <Grid container>

              {
                urlImagen.map((value, index) => (
                  <>
                    <Grid item xs={12}>
                      <Typography>
                        Inventariable {index + 1}
                      </Typography>
                    </Grid>
                    <Grid item container xs={12} key={index} justifyContent={'center'}>
                      <CardMedia
                        component="img"
                        alt="Vista Previa"
                        sx={{
                          maxHeight: 300,
                          maxWidth: 300,
                          objectFit: 'cover',
                        }}
                        image={value}
                      />
                    </Grid>
                  </>
                ))
              }
            </Grid>
          }
        />
      }
    </>
  )

}